module.exports = __webpack_public_path__ + "img/encourage-bg.79def69c.png";